export default __webpack_public_path__ + "static/media/Aura-Egg__17.97ba29ae.png";